import { connect } from 'react-redux';
import { COUNTRY_NAME_BY_CODE } from '../../../main/shops/constants';
import { activeShopCashRegisterCountBillsDefault, getActiveShopCountry } from '../../../auth/selectors';

const mapStateToProps = (state) => {
  const isUsShop = getActiveShopCountry(state) === COUNTRY_NAME_BY_CODE.US;
  const isCaShop = getActiveShopCountry(state) === COUNTRY_NAME_BY_CODE.CA;
  const countBillsDefaultSetting = !!activeShopCashRegisterCountBillsDefault(state);

  return ({
    countBillsByDefault: {
      whenOpening: (isUsShop || isCaShop) && countBillsDefaultSetting,
      whenClosing: (isUsShop || isCaShop) && countBillsDefaultSetting,
    },
    suggestCountingBills: {
      whenOpening: isUsShop && !countBillsDefaultSetting,
      whenClosing: isUsShop && !countBillsDefaultSetting,
    },
  });
};

export default connect(mapStateToProps);
